import SectionHead from "./SectionHead";

const STEPS = [
  { no: "1", title: "先扫导读，建立全局", desc: "花一分钟看完全程章节地图，知道整件事有哪几段、重点在哪。", href: "#overview", label: "全程导读" },
  { no: "2", title: "顺时间线，把因果补齐", desc: "跟着 8 话时间线从起因读到收尾，前因后果一次理清。", href: "#timeline", label: "事件时间线" },
  { no: "3", title: "直奔大结局，看结果落地", desc: "不想被剧透细节就看这里，胜负、去向、彩蛋三件事直接给答案。", href: "#finale", label: "大结局复盘" },
  { no: "4", title: "回头补名场面，接上梗", desc: "看完主线再刷高光切片，讨论区里的梗和引用就都接得上了。", href: "#moments", label: "名场面" },
  { no: "5", title: "加入讨论，参与站队", desc: "对结局满意吗？五个收尾话题等你表态，也可以投出你那一票。", href: "#topics", label: "收尾讨论" },
];

export default function Guide() {
  return (
    <section id="guide" className="scroll-mt-20 bg-background-50 py-14 md:py-20">
      <div className="page-shell grid grid-cols-1 gap-8 lg:grid-cols-3">
        <div>
          <SectionHead
            kicker="补课指南"
            title="新来的，按这个顺序看最顺"
            desc="错过全程也别慌。下面是编辑部建议的补课路线，照着走，基本就能无缝接上所有人的聊天话题。"
          />
          <aside className="mt-6 rounded-2xl border border-primary-200 bg-primary-100/60 p-5">
            <div className="flex items-center gap-2 text-sm font-black text-primary-700">
              <i className="ri-time-line text-lg" aria-hidden="true" />
              只有十分钟？
            </div>
            <p className="mt-2 text-sm leading-relaxed text-foreground-800">
              那就只看时间线里的第 07 话 + 大结局板块即可。核心结果都在那两处，足够你听懂九成讨论。
            </p>
            <a
              href="#timeline"
              className="mt-3 inline-flex items-center gap-1 text-xs font-bold text-primary-600 hover:underline"
            >
              快速跳到时间线
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </a>
          </aside>
        </div>

        <ol className="lg:col-span-2">
          {STEPS.map((s, i) => (
            <li key={s.no} className="flex gap-5 border-b border-background-200 py-5 first:pt-0 last:border-b-0">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-accent-500 font-display text-xl text-background-50">
                {s.no}
              </span>
              <div className="min-w-0">
                <h3 className="text-base font-black text-foreground-950 md:text-lg">{s.title}</h3>
                <p className="mt-1 text-sm text-foreground-700">{s.desc}</p>
                <a
                  href={s.href}
                  className="mt-2 inline-flex items-center gap-1 text-xs font-bold text-primary-600 hover:underline"
                >
                  {s.label}
                  <i className="ri-arrow-right-line" aria-hidden="true" />
                </a>
              </div>
              <span className="ml-auto hidden self-center font-display text-4xl text-foreground-200 sm:block">
                {String(i + 1).padStart(2, "0")}
              </span>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}